import React, { useEffect, useState, Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { SettingsIcon, TrashIcon } from 'lucide-react';
import { FormSection, TextField, TextAreaField, SelectField } from '../components/FormComponents';
import { masterDataSets } from '../data/mockData';
export function MasterSettingsForm() {
  const {
    type,
    id
  } = useParams<{
    type: string;
    id: string;
  }>();
  const navigate = useNavigate();
  const isEditMode = Boolean(id);
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    description: '',
    status: 'Active'
  });
  useEffect(() => {
    if (isEditMode && type && masterDataSets[type]) {
      const existingItem = masterDataSets[type].find(item => item.id === id);
      if (existingItem) {
        setFormData({
          code: existingItem.code,
          name: existingItem.name,
          description: existingItem.description || '',
          status: existingItem.status
        });
      }
    }
  }, [id, type, isEditMode]);
  if (!type || !masterDataSets[type]) {
    return <div className="p-8 text-center text-gray-500" data-id="element-1223">
        Invalid master data type.
      </div>;
  }
  const formatTitle = (str: string) => {
    return str.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };
  const entityName = formatTitle(type);
  const singularEntityName = entityName.endsWith('s') ? entityName.slice(0, -1) : entityName;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(`${singularEntityName} ${isEditMode ? 'updated' : 'created'} successfully!`);
    navigate(`/master-settings/${type}`);
  };
  return <div className="space-y-6 max-w-3xl mx-auto" data-id="element-1224">
      <div className="flex items-center gap-3" data-id="element-1225">
        <div className="p-3 bg-slate-100 rounded-lg border border-slate-200" data-id="element-1226">
          <SettingsIcon className="h-6 w-6 text-slate-600" data-id="element-1227" />
        </div>
        <div data-id="element-1228">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1229">
            {isEditMode ? `Edit ${singularEntityName}` : `New ${singularEntityName}`}
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1230">
            {isEditMode ? `Update details for this ${singularEntityName.toLowerCase()} record.` : `Add a new ${singularEntityName.toLowerCase()} to the system.`}
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="bg-white shadow-sm rounded-lg border border-gray-200 p-6 md:p-8" data-id="element-1231">
        <FormSection title="Basic Details" data-id="element-1232">
          <TextField label="Code" value={formData.code} onChange={e => setFormData({
          ...formData,
          code: e.target.value
        })} placeholder={`e.g., ${type.substring(0, 3).toUpperCase()}-001`} required data-id="element-1233" />
          <TextField label="Name" value={formData.name} onChange={e => setFormData({
          ...formData,
          name: e.target.value
        })} placeholder={`Enter ${singularEntityName.toLowerCase()} name`} required data-id="element-1234" />
          <TextAreaField label="Description" value={formData.description} onChange={e => setFormData({
          ...formData,
          description: e.target.value
        })} rows={3} placeholder="Optional description..." data-id="element-1235" />
          <SelectField label="Status" value={formData.status} onChange={e => setFormData({
          ...formData,
          status: e.target.value
        })} options={[{
          value: 'Active',
          label: 'Active'
        }, {
          value: 'Inactive',
          label: 'Inactive'
        }]} required data-id="element-1236" />
        </FormSection>

        <div className="mt-8 pt-5 border-t border-gray-200 flex items-center justify-between" data-id="element-1237">
          {isEditMode ? <button type="button" onClick={() => {
          if (confirm(`Are you sure you want to delete this ${singularEntityName.toLowerCase()}?`)) {
            alert(`${singularEntityName} deleted successfully!`);
            navigate(`/master-settings/${type}`);
          }
        }} className="inline-flex items-center px-4 py-2 border border-red-300 shadow-sm text-sm font-medium rounded-md text-red-700 bg-red-50 hover:bg-red-100" data-id="element-1238">
              <TrashIcon className="h-4 w-4 mr-2" data-id="element-1239" />
              Delete
            </button> : <div data-id="element-1240" />}
          <div className="flex space-x-3" data-id="element-1241">
            <button type="button" onClick={() => navigate(`/master-settings/${type}`)} className="px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-1242">
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-1243">
              {isEditMode ? 'Save Changes' : 'Create Record'}
            </button>
          </div>
        </div>
      </form>
    </div>;
}